import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { motion } from 'framer-motion';
import { Loader2, ArrowRight } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_bill-compare-4/artifacts/1n4zuw4u_energyLab.gif";
const BG_URL = "https://customer-assets.emergentagent.com/job_bill-compare-4/artifacts/f289s540_Bolletto%20sfondo.png";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(email, password);

    if (!result.success) {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Branded background */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        {/* Gradient background */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#1B3A1B] via-[#2D5A2D] to-[#4CAF50]" />
        {/* Decorative circles */}
        <div className="absolute -top-20 -left-20 w-96 h-96 rounded-full bg-[#4CAF50]/20 blur-3xl" />
        <div className="absolute -bottom-32 -right-32 w-[500px] h-[500px] rounded-full bg-[#81C784]/15 blur-3xl" />
        <div className="absolute top-1/4 right-10 w-64 h-64 rounded-full bg-[#A5D6A7]/10 blur-2xl" />
        {/* Grid pattern */}
        <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
        {/* Logo centered */}
        <div className="relative z-10 flex flex-col items-center justify-center w-full gap-6">
          <img src="https://customer-assets.emergentagent.com/job_bill-compare-4/artifacts/pjfx4a77_BOLLETTO.png" alt="Bolletto" className="h-32 w-auto drop-shadow-2xl brightness-0 invert" />
        </div>
      </div>

      {/* Right side - Login form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-[#F4F7F4]">
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          {/* Card */}
          <div className="el-card p-8">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-medium text-[#1B291B]">
                Accedi
              </h2>
              <p className="text-[#5C6E5C] mt-2">
                Inserisci le tue credenziali per continuare
              </p>
            </div>

            {error && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm"
                data-testid="login-error"
              >
                {error}
              </motion.div>
            )}

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="el-label block mb-2">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="el-input w-full"
                  placeholder="nome@esempio.it"
                  required
                  data-testid="login-email-input"
                />
              </div>

              <div>
                <label className="el-label block mb-2">Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="el-input w-full"
                  placeholder="••••••••"
                  required
                  data-testid="login-password-input"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="el-btn-primary w-full flex items-center justify-center gap-2"
                data-testid="login-submit-btn"
              >
                {loading ? (
                  <Loader2 className="w-5 h-5 animate-spin" />
                ) : (
                  <>
                    Accedi
                    <ArrowRight className="w-5 h-5" />
                  </>
                )}
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
